// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

window.showToast = (message) => {
  const container = document.getElementById("toast-container")
  if (!container) return

  const toast = document.createElement("div")
  toast.className = "px-6 py-3 bg-ink border-2 border-gold text-gold font-mono text-sm uppercase tracking-wider shadow-[0_0_20px_rgba(212,175,55,0.3)]"
  toast.textContent = `[ ${message} ]`

  container.appendChild(toast)

  setTimeout(() => {
    toast.style.opacity = "0"
    toast.style.transition = "opacity 0.3s"
    setTimeout(() => toast.remove(), 300)
  }, 2000)
}
